module.exports = __webpack_public_path__ + "img/pic_zw@2x.0fad63fa.png";